module.exports = __webpack_public_path__ + "media/svg/music-note-9d6c732b.svg";